import { BaseModel } from '../../global/models';
import { DocReference } from '../../global/models/doc-reference.models';
import { PromoRef } from "../promo";


export enum CouponType {
  PERCENT = "PERCENT",
  FIXED = "FIXED"
}

export interface BaseCoupon extends BaseModel {
  code: string;  // coupon code (always take to uppercase)
  title?: string;
  type: CouponType;
  amount: number;
  maxAmount?: number; //if type is percent, this represents the max absolute amount to discount.
  currency: string;  //amount currency
  enabled?: boolean;
  freeShipping?: boolean;
  limit: number; // 0: unlimited
  usage: number; // actual usage times of this coupon
}

export interface Coupon extends BaseCoupon {
  message?: string;
  description?: string; // admin reference, not visible to customers
  valid: boolean;
  bindingDiscountEnabled?: boolean;
  discountByRanges?: boolean;
  discountRanges?: any[];
  promo?: PromoRef;
}

export interface UserCoupon extends BaseCoupon {
  firstPurchaseOnly?: boolean; // valid only on first purchase
  startDate?: Date;  // from when this coupon starts to be effective
  expirationDate?: Date;
  private?: boolean;
  recurrent?: boolean;
  multiUsage?: boolean;
}

export interface CouponTransaction extends BaseModel {
  couponId: string;  // same as parent coupon
  couponCode: string;  // same as parent coupon
  userId: string;
  amount: number;  // actual amount used from the coupon
  currency: string;
  ref: DocReference; // reference to another document causing this transaction (usually, order)
}

export interface CouponUses {
  thisMonth: {
    count: number;
    amount: number;
  };
  lastMonth: {
    count: number;
    amount: number;
  };
}

export interface CouponMonthlyUsageBucket {
  /** Month key formatted as 'yyyy-MM'. */
  month: string;
  /** Number of orders using the coupon during the month. */
  count: number;
}
